// extracted by mini-css-extract-plugin
export default {"card":"Cards_card__y2l3w","cardContent":"Cards_cardContent__zspnM","cardTitle":"Cards_cardTitle__p3zeK","cardDescription":"Cards_cardDescription__cQJQJ"};